export default __webpack_public_path__ + "static/media/martin_jump.3146d085.jpg";